import { handleApiErrorResponse, handleApiThrowError } from "./errorHandling";
import { apiUrl } from "./apiConfig";


type manufacturer = 'Volvo' | 'BMW' | 'Audi' | 'Toyota' | 'Ford';
type carModel = 'XC70' | 'V70' | 'XC90' | 'X5' | 'X3' | 'A4' | 'A6' | 'Camry' | 'Corolla' | 'Mustang' | 'F-150';

export interface iNewOrder {
    carModel: carModel
    price: number
    quantity: number
    manufacturer: manufacturer;
}

export interface IOrder extends iNewOrder {
    _id: string
    createdAt: string
    updatedAt: string
}

export async function getOrders(): Promise<IOrder[]> {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(apiUrl('/order/getAllOrders'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            await handleApiErrorResponse(response, 'Fetching orders failed');
        }
        const resData = await response.json();
        return resData.orders as IOrder[];
    } catch (error) {
        handleApiThrowError(error, 'Fetching orders failed', 'Order fetching Error');
    }
}

export async function createOrder(orderData: iNewOrder): Promise<IOrder> {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(apiUrl('/order/createOrder'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(orderData)
        });
        if (!response.ok) {
            await handleApiErrorResponse(response, 'Creating order failed');
        }
        const resData = await response.json();
        return resData.order as IOrder;
    } catch (error) {
        handleApiThrowError(error, 'Creating order failed', 'Order creation Error');
    }
}

export async function deleteOrder(orderId: string): Promise<void> {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(apiUrl(`/order/deleteOrder/${orderId}`), {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            await handleApiErrorResponse(response, 'Deleting order failed');
        }
    } catch (error) {
        handleApiThrowError(error, 'Deleting order failed', 'Order deletion Error');
    }
}